import { Component, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StatusItem } from './status-dropdown.model';
import { UtilityService } from '@shared/services/utility.service';
import { ProgramApplication } from '@program/shared/program-application.model';

@Component({
  selector: 'oes-status-dropdown',
  standalone: true,
  templateUrl: './status-dropdown.component.html',
  styleUrls: ['./status-dropdown.component.scss'],
  imports: [CommonModule, BsDropdownModule, TranslateModule]
})
export class StatusDropdownComponent implements OnInit {
  label = input.required<string>();
  statuses = input.required<StatusItem[]>();
  programApplication = input.required<ProgramApplication>();

  onStatusChange = output<StatusItem>();

  selectedStatus = signal<StatusItem>(null);

  private readonly _utilityService = inject(UtilityService);
  private readonly _translateService = inject(TranslateService);

  constructor() {
    effect(() => {
      this.onStatusChange.emit(this.selectedStatus());
    });
  }

  ngOnInit(): void {
    this.selectedStatus.set(this.statuses().find(s => s.name === this.programApplication().status) || null);
  }

  onSelectStatus(value: StatusItem): void {
    this.selectedStatus.set(value);
  }

  getTextColor(hexCode: string) {
    if (hexCode) {
      return this._utilityService.findTextColor(hexCode);
    }
  }

  getStatusName(name: string): string {
    if (!name) {
      return '';
    }

    if (name === 'Selected' && !this.isLastStage() && !this.isSccSubmissionType()) {
      return `${name} ${this._translateService.instant('program.pre-qualification.status.for-next')}`;
    }

    return name;
  }

  isSccSubmissionType(): boolean {
    return this.programApplication().program.submissionType === 'SCC';
  }

  isLastStage(): boolean {
    return this.programApplication().programApplicationStageConfiguration?.lastStage;
  }
}
